<template>
  <div id="intersection-observer">
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    initObserver: {
      type: Boolean,
      default: false
    },
    disconnectObserver: {
      type: Boolean,
      default: false
    },
    threshold: {
      type: Number,
      required: false,
      default: 1.0
    }
  },
  data: () => ({
    observer: null
  }),
  watch: {
    disconnectObserver(value) {
      if (value) this.observer.disconnect();
      return;
    }
  },
  mounted() {
    if (this.initObserver) this.triggerObserver();
    return;
  },
  destroyed() {
    if (this.initObserver) this.observer.disconnect();
    return;
  },
  methods: {
    triggerObserver() {
      let options = {
        root: null,
        rootMargin: '1px',
        threshold: this.threshold
      };

      let callback = entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.$emit('intersect');
          }
        });
      };

      this.observer = new IntersectionObserver(callback, options);
      this.observer.observe(this.$el);
    }
  }
};
</script>
